"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuppressedDefaultActionLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SuppressedDefaultActionLink_module_css_1 = __importDefault(require("./SuppressedDefaultActionLink.module.css"));
const web_env_1 = require("@snapchat/web-env");
/**
 * FIXME: This is bad practice. We should not be using onClick on links as links should behave as links. Suppressing their actions hurt us in SEO for cross-linking pages when search engines crawl them.
 * FIXME: Remove this component from all places
 *
 *
 * This is a link component that is used to help us logging metrics on <a> tag clicks. This component waits until metrics are submitted before leaving the page for the destination link.
 */
function SuppressedDefaultActionLink({ link, logMetric, children, openInNewTab, }) {
    const handleClick = (0, react_1.useCallback)((e) => {
        if (!logMetric) {
            return;
        }
        const asyncHandleClick = async () => {
            try {
                await logMetric();
            }
            finally {
                // Send to the destination link programmatically
                const windowObj = (0, web_env_1.getWindow)();
                if (openInNewTab) {
                    (0, web_env_1.getWindow)()?.open(link, "_blank")?.focus();
                }
                else if (windowObj) {
                    windowObj.location.href = link;
                }
            }
        };
        e.preventDefault();
        void asyncHandleClick();
    }, [logMetric, openInNewTab, link]);
    return ((0, jsx_runtime_1.jsx)("a", { className: SuppressedDefaultActionLink_module_css_1.default.link, href: link, onClick: handleClick, children: children }));
}
exports.SuppressedDefaultActionLink = SuppressedDefaultActionLink;
//# sourceMappingURL=SuppressedDefaultActionLink.js.map